import ListTenant from './ListTenant';

export default ListTenant;
